/* ============================================================================
   NeoSpherium · Fenggy motion tiles.
   Real Fenggy 23AW runway footage, cool-graded into short muted loops, used as
   UNCLICKABLE "movement" tiles: interspersed among the Fenggy PLP product grid
   (looks like a product card, but no link), and as a motion band on the Fenggy
   District page.

   Safe by design:
     - Fenggy surfaces only (early-returns elsewhere).
     - Tiles are NOT .edit__tile and carry no data-cf-* attributes, so the
       collection filter/sort/quick-add engine never touches them.
     - The grid re-appends product tiles on every sort/filter; a childList-only
       MutationObserver (disconnected while we rewrite) re-interspersees the
       motion tiles after each change · no infinite loop.
     - No `autoplay` attribute: an IntersectionObserver plays only on-screen
       videos and pauses the rest (perf). Under prefers-reduced-motion we never
       play · the poster frame shows instead (full a11y).
   Reversible: delete this file + the load line, the data blob in ns-collection,
   the band in ns-district, and the .ns-motion-* CSS.
   ========================================================================== */
(function () {
  'use strict';
  if (window.__nsFenggyMotion) return;
  window.__nsFenggyMotion = true;

  var reduce = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* lazy play/pause · never plays under reduced-motion */
  var lazy = ('IntersectionObserver' in window) ? new IntersectionObserver(function (ents) {
    ents.forEach(function (en) {
      var v = en.target.tagName === 'VIDEO' ? en.target : en.target.querySelector('video');
      if (!v) return;
      if (en.isIntersecting && !reduce) {
        if (v.preload === 'none') { v.preload = 'auto'; v.load(); }
        if (v.dataset.nsRate) { try { v.playbackRate = parseFloat(v.dataset.nsRate); } catch (e) {} } /* keep PLP clips 25% slower */
        var p = v.play(); if (p && p.catch) p.catch(function () {});
      } else {
        try { v.pause(); } catch (e) {}
      }
    });
  }, { rootMargin: '300px 0px' }) : null;

  function buildVideo(clip) {
    var v = document.createElement('video');
    v.muted = true; v.loop = true; v.playsInline = true;
    v.setAttribute('muted', ''); v.setAttribute('playsinline', '');
    v.preload = 'none'; v.tabIndex = -1;
    v.dataset.nsRate = '0.75';            /* PLP motion clips play 25% slower (Fahad 2026-06-26) */
    try { v.playbackRate = 0.75; } catch (e) {}
    if (clip.poster) v.poster = clip.poster;
    var s = document.createElement('source'); s.src = clip.src; s.type = 'video/mp4';
    v.appendChild(s);
    return v;
  }

  /* -------- 1. PLP interspersion (collection-plp--fenggy) ----------------- */
  (function plp() {
    var root = document.querySelector('.collection-plp--fenggy');
    if (!root) return;
    var grid = root.querySelector('[data-cf-grid]') || root.querySelector('.edit__grid');
    if (!grid) return;
    var blob = document.querySelector('[data-fenggy-motion]');
    if (!blob) return;
    var clips;
    try { clips = JSON.parse(blob.textContent); } catch (e) { return; }
    if (!clips || !clips.length) return;

    var EVERY = 6; /* one motion tile after roughly every 6 visible products */
    var tiles = clips.map(function (c) {
      var t = document.createElement('div');
      t.className = 'ns-motion-tile';
      t.setAttribute('aria-hidden', 'true');
      var img = document.createElement('div'); img.className = 'ns-motion-img';
      if (reduce) {
        if (c.poster) { var p = document.createElement('img'); p.src = c.poster; p.alt = ''; p.loading = 'lazy'; p.decoding = 'async'; img.appendChild(p); }
      } else {
        img.appendChild(buildVideo(c));
      }
      var tag = document.createElement('span'); tag.className = 'ns-motion-tag'; tag.textContent = c.label || 'Fenggy in motion';
      t.appendChild(img); t.appendChild(tag);
      return t;
    });

    function distribute() {
      tiles.forEach(function (t) { if (t.parentNode) t.parentNode.removeChild(t); });
      var prods = [];
      for (var i = 0; i < grid.children.length; i++) {
        var c = grid.children[i];
        /* grid items are .edit__cell wrappers (the .edit__tile <a> is nested inside) */
        if (c.nodeType === 1 && c.classList.contains('edit__cell') && !c.classList.contains('ns-motion-tile') && !c.hidden) prods.push(c);
      }
      var mi = 0;
      for (var pos = EVERY; pos < prods.length && mi < tiles.length; pos += EVERY + 1) {
        grid.insertBefore(tiles[mi], prods[pos]);
        if (lazy) lazy.observe(tiles[mi]);
        mi++;
      }
    }

    distribute();

    if ('MutationObserver' in window) {
      /* The filter/sort engine re-appends every product wrapper on each change,
         which clusters our tiles at the front; re-intersperse after it settles.
         setTimeout (not rAF · rAF is throttled when the tab isn't painting). */
      var pending = false;
      var mo = new MutationObserver(function () {
        if (pending) return;
        pending = true;
        setTimeout(function () {
          pending = false;
          mo.disconnect();
          distribute();
          mo.observe(grid, { childList: true });
        }, 60);
      });
      mo.observe(grid, { childList: true });
    }
  })();

  /* -------- 2. Motion band (Fenggy District page) ------------------------- */
  (function band() {
    var bands = document.querySelectorAll('[data-ns-motion-band]');
    if (!bands.length) return;
    bands.forEach(function (b) {
      b.querySelectorAll('video').forEach(function (v) {
        if (reduce) { try { v.removeAttribute('autoplay'); v.pause(); } catch (e) {} }
        else if (lazy) { lazy.observe(v); }
      });
    });
  })();
})();
